import { Avatar, Chip, IconButton, Tooltip, Typography } from '@material-ui/core';
import { StyledTableCell } from './tableStyle';
import './tcardTemplate.scss';
import moment from 'moment';
import { AppStorage } from '../../../../../Core/Service/storage-service';
import TodayIcon from '@material-ui/icons/Today';
import AddBoxIcon from '@material-ui/icons/AddBox';
import { useState, useContext } from 'react';
import DialogComp from '../../../../../Core/Controls/Dialog/DialogComp';
import { TCaredDashboardContext } from '../tCaredDashboard-Provider';
// import DialogComp from './../../../../../Core/Modal/dialogModal';

export default function TechnicianShift(props) {
    const { tCardList, handleCalendarButtonClick, dt } = props;
    const portalSetting = AppStorage.getPortalSetting();
    const { handleUnassignTechnician, openHoliday } = useContext(TCaredDashboardContext);

    const [state, setState] = useState({
        isTechShow: false,
        currentDate: dt,
        shiftName: '',
        shiftID: '',
        bgcolor: '',
        txtcolor: '',
        br: '',
        technicians: []
    });

    const isShowtech = (data) => {
        if (data)
            setState((st) => ({
                ...st,
                isTechShow: true,
                shiftName: data.shiftName,
                shiftID: data.shiftID,
                bgcolor: data.bgcolor,
                txtcolor: data.txtcolor,
                br: data.br,
                technicians: data.technicians
            }));
        else setState((st) => ({ ...st, shift: '', isTechShow: false, techList: [] }));
    };

    const groupedByShift = Object.values(
        tCardList.techniciansShift
            .filter((m) => moment(m.shiftDate).format('YYYY-MM-DD') === moment(dt).format('YYYY-MM-DD'))
            .reduce((acc, item) => {
                if (!acc[item.shiftName]) {
                    acc[item.shiftName] = {
                        shiftName: item.shiftName,
                        shiftID: item.shiftID,
                        bgcolor: item.bgcolor,
                        txtcolor: item.txtcolor,
                        technicians: [],
                        br: item.br
                    };
                }

                acc[item.shiftName].technicians.push({
                    ...item
                });

                return acc;
            }, {})
    );

    console.log(groupedByShift);

    return (
        <>
            <StyledTableCell align="center" width={`${Math.floor(100 / tCardList.closeDays.length)}%`} className="holiday-container">
                <div className="holiday-container-header">
                    <Typography className="holiday-container-lable"> Technicians Working</Typography>
                    {/* <Tooltip title="Add Technician" aria-label="UserHoliday">
                        <IconButton size="medium" className="holiday-container-icon-btn" onClick={() => handleCalendarButtonClick(dt)}>
                            <AddBoxIcon fontSize="small" className="holiday-container-icon" />
                        </IconButton>
                    </Tooltip> */}
                </div>{' '}
                <div className={`holiday-container-list custom-scroll`}>
                    {groupedByShift.map((k) => (
                        <div
                            style={{
                                background: k.bgcolor,
                                color: k.txtcolor,
                                borderBottom: `1px solid ${k.bgcolor}`,
                                padding: 1
                            }}
                        >
                            <Typography
                                style={{
                                    color: k.txtcolor,
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    cursor: 'pointer'
                                }}
                                onClick={() => isShowtech(k)}
                                className="holiday-container-list-name"
                            >
                                <span>{k.shiftName}</span>
                                <span>{k.technicians.length}</span>
                            </Typography>
                        </div>
                    ))}
                </div>
            </StyledTableCell>
            {state.isTechShow ? (
                <DialogComp
                    title={`${state.br} - ${moment(dt).format('dddd')}  ${moment(dt).format('DD MMM YYYY')}`}
                    onClose={() => isShowtech(null)}
                    maxWidth="md"
                >
                    <div
                        style={{
                            padding: 12,
                            background: '#fafafa',
                            border: '1px solid #3741513f',
                            // maxHeight: 500,
                            minHeight: 600,
                            overflow: 'auto'
                        }}
                    >
                        <div
                            variant="subtitle1"
                            style={{
                                fontWeight: 600,
                                textAlign: 'center',
                                minWidth: 450,
                                marginBottom: 6,
                                color: state.txtcolor,
                                background: state.bgcolor,
                                padding: 5
                            }}
                        >
                            {state.shiftName}
                        </div>

                        {state?.technicians?.map((tech, index) => (
                            <div
                                key={tech.technicianUserID}
                                onClick={() => isShowtech(tech)}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    padding: '4px 10px',
                                    marginBottom: 3,
                                    background: index % 2 ? '#f5f5f5' : '#fff',
                                    borderBottom: '1px solid #e5e7eb',
                                    borderRadius: 3,
                                    cursor: 'pointer'
                                }}
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 8
                                    }}
                                >
                                    <Avatar
                                        style={{
                                            width: 28,
                                            height: 28,
                                            fontSize: 13,
                                            fontWeight: 600,
                                            bgcolor: tech.bgcolor,
                                            color: tech.txtcolor
                                        }}
                                    >
                                        {tech.technicianUserName?.charAt(0)?.toUpperCase()}
                                    </Avatar>

                                    <Typography
                                        style={{
                                            fontSize: 13,
                                            fontWeight: 500,
                                            color: '#1f2937'
                                        }}
                                    >
                                        {tech.technicianUserName}
                                    </Typography>
                                </div>
                                <div>
                                    <Chip
                                        label="Unassign"
                                        size="small"
                                        style={{
                                            height: 20,
                                            fontSize: 10,
                                            fontWeight: 600,
                                            '& .MuiChip-label': {
                                                px: 1
                                            }
                                        }}
                                        color="success"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleUnassignTechnician(dt, tech, state);
                                        }}
                                    />
                                    <Chip
                                        label="Holiday"
                                        size="small"
                                        style={{
                                            height: 20,
                                            fontSize: 10,
                                            fontWeight: 600,
                                            '& .MuiChip-label': {
                                                px: 1
                                            }
                                        }}
                                        color="success"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            openHoliday(dt, tech, state);
                                        }}
                                    />
                                    {tech.isOnCall && (
                                        <Chip
                                            label="On Call"
                                            size="small"
                                            style={{
                                                height: 20,
                                                fontSize: 10,
                                                fontWeight: 600,
                                                '& .MuiChip-label': {
                                                    px: 1
                                                }
                                            }}
                                            color="success"
                                        />
                                    )}
                                </div>
                            </div>
                        ))}
                        <div
                            // key={tech.technicianUserID}
                            onClick={() =>
                                handleCalendarButtonClick(dt, {
                                    shiftID: state.shiftID,
                                    shiftName: state.shiftName
                                })
                            }
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                padding: '4px 10px',
                                marginBottom: 3,
                                background: '#fff',
                                borderBottom: '1px solid #e5e7eb',
                                borderRadius: 3,
                                cursor: 'pointer'
                            }}
                        >
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 8
                                }}
                            >
                                <Typography
                                    style={{
                                        fontSize: 13,
                                        fontWeight: 500,
                                        color: '#1f2937'
                                    }}
                                >
                                    + Assign Technician
                                </Typography>
                            </div>
                        </div>
                    </div>
                </DialogComp>
            ) : null}
        </>
    );
}
